import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./SubscriptionFilter.module.scss";

type SubscriptionValue = "subscription" | "one_time";

const options: FilterMultiselectOption[] = [
    {
        value: "subscription",
        label: "Subscription",
        searchableLabel: "subscription",
    },
    { value: "one_time", label: "One-time", searchableLabel: "one-time" },
];

function isSubscriptionToValue(
    isSubscription: boolean | undefined,
): SubscriptionValue[] {
    if (isSubscription === true) {
        return ["subscription"];
    }
    if (isSubscription === false) {
        return ["one_time"];
    }
    return [];
}

export const SubscriptionFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = isSubscriptionToValue(filters.isSubscription);

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val as SubscriptionValue[];
                    // Single-select: pick the newly added value
                    const added = selected.find(
                        (v) =>
                            (v === "subscription" &&
                                filters.isSubscription !== true) ||
                            (v === "one_time" &&
                                filters.isSubscription !== false),
                    );
                    if (selected.length === 0) {
                        onChange({ isSubscription: undefined });
                        return;
                    }
                    if (added === undefined) {
                        // Unreachable: FilterMultiselect always toggles exactly one
                        // item, so `added` is always defined when selection is
                        // non-empty. Guard kept for safety.
                        return;
                    }
                    if (added === "subscription") {
                        onChange({ isSubscription: true });
                    } else {
                        onChange({ isSubscription: false });
                    }
                }}
                name="isSubscription"
                onBlur={noop}
            />
        </div>
    );
};
